import { useEffect, useState } from "react";
import type { ImageBlock } from "./types";

export function BlockImage({ block, loadImage }: { block: ImageBlock; loadImage?: (fileId: string) => Promise<Blob> }) {
  const [source, setSource] = useState("");
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!loadImage) return;
    let active = true;
    let objectUrl = "";
    void loadImage(block.file.id).then((blob) => {
      if (!active) return;
      objectUrl = URL.createObjectURL(blob);
      setSource(objectUrl);
    }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [block.file.id, loadImage]);

  if (failed) return <div className="block-image-fallback">이미지를 불러오지 못했습니다. · {block.file.originalName}</div>;
  if (!source) return <div className="block-image-loading">이미지를 불러오는 중…</div>;
  return <img
    src={source}
    alt={block.altText || block.caption || block.file.originalName}
    style={{
      width: block.width ? `${block.width}px` : undefined,
      maxWidth: "100%",
      height: "auto",
      aspectRatio: block.width && block.height ? `${block.width} / ${block.height}` : undefined,
    }}
  />;
}
